import { TERMINAL_PAYMENT_HISTORY_ENABLED } from '../../Common/config/terminalFeatures';
import { useDispatch, useSelector } from 'react-redux';
import '../../Common/css/app.css';
import '../../Common/css/main.css';
import '../../Common/css/common.css';
import '../../Common/css/payment.css';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle, setPharmacyList, checkLogin, setOtpVerified } from '../../Common/store';
import { terminalLogout } from '../api/cp';
import AppLogoutConfirmModal from '../components/AppLogoutConfirmModal';
import axios from 'axios';
import { Search, X, LogOut } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { getAppLogoAssetUrl, getAppLogoFallbackUrl, getAppHeaderLogoStyle, getTerminalHeaderStyle } from '../../Common/constants/adminImages';

function AppDashboard_1({ hideHeader = false }) {
    let dispatch = useDispatch()
    let navigate = useNavigate()

    let MyData = useSelector((state) => { return state.MyData })
    const [searchTerm, setSearchTerm] = useState("");
    const [paidPharmacies, setPaidPharmacies] = useState([]);
    const [foldNonFranchise, setFoldNonFranchise] = useState(false);   // 비가맹 업체 접기
    const [foldAllList, setFoldAllList] = useState(false);             // 전체업체목록 리스트 접기 (검색창은 유지)
    const [logoutModalOpen, setLogoutModalOpen] = useState(false);
    const [logoutLoading, setLogoutLoading] = useState(false);
    // 마지막 좌표를 localStorage에서 복원 (뒤로가기 시 화면 유지용)
    const [userLocation, setUserLocation] = useState(() => {
        try {
            const saved = localStorage.getItem("lastUserLocation");
            if (!saved) return null;
            const parsed = JSON.parse(saved);
            if (parsed && typeof parsed.lat === "number" && typeof parsed.lng === "number") {
                return { lat: parsed.lat, lng: parsed.lng };
            }
        } catch (e) { }
        return null;
    });           // GPS { lat, lng }
    const [locationLoading, setLocationLoading] = useState(false);       // 위치 요청 중
    const [locationError, setLocationError] = useState(null);         // 위치 오류 메시지
    const pharmacyListLoaded = useSelector((state) => state.pharmacyList?.loaded ?? false);
    const pharmacyList = useSelector((state) => state.pharmacyList?.list ?? []);
    const [pharmacyLoading, setPharmacyLoading] = useState(!pharmacyListLoaded); // 뒤로가기 시 Redux 있으면 로딩 안 함
    const [listVisibleCount, setListVisibleCount] = useState(150); // 전체목록 최적화: 처음 150개만 렌더, 스크롤 시 추가
    const listScrollRef = useRef(null);

    // 결제 완료된 약국 목록 불러오기 함수
    const loadPaidPharmacies = () => {
        const saved = localStorage.getItem("paidPharmacies");
        if (saved) {
            try {
                setPaidPharmacies(JSON.parse(saved));
            } catch (e) {
                setPaidPharmacies([]);
            }
        } else {
            setPaidPharmacies([]);
        }
    };

    useEffect(() => {
        dispatch(change_Current_Location("대시보드"))
        dispatch(changeHeaderTitle({
            mainTitle: "대시보드",
            subTitle: ""
        }))

        // 결제 완료된 약국 목록 불러오기
        loadPaidPharmacies();

        // 페이지 포커스 시 결제 완료 상태 다시 불러오기 (결제 완료 후 돌아왔을 때)
        const handleFocus = () => {
            loadPaidPharmacies();
        };

        window.addEventListener('focus', handleFocus);

        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, [dispatch])

    // 이미 Redux에 있으면 로딩 해제
    useEffect(() => {
        if (pharmacyListLoaded) setPharmacyLoading(false);
    }, [pharmacyListLoaded]);

    // 약국 전체데이터 콘솔 출력 (디버깅용)
    useEffect(() => {
        if (pharmacyList.length > 0) {
            console.log("약국 전체데이터", pharmacyList.length, "개", pharmacyList);
        }
    }, [pharmacyList]);

    // 전체약국목록: 캐시 복원 후 API 호출. 새 데이터 수신 시 캐시·Redux 대체
    const PHARMACY_CACHE_KEY = "pharmacyListCache";
    useEffect(() => {
        const cached = localStorage.getItem(PHARMACY_CACHE_KEY);
        if (cached) {
            try {
                const parsed = JSON.parse(cached);
                const list = parsed?.list ?? parsed;
                if (Array.isArray(list) && list.length > 0) {
                    dispatch(setPharmacyList(list));
                    setPharmacyLoading(false);
                }
            } catch (e) { }
        }

        const baseUrl = process.env.REACT_APP_API || "";
        axios.get(baseUrl + "/api/terminal/pharmacy/with-mapping/all", { withCredentials: true })
            .then((res) => {
                const data = res?.data;
                if (data?.code === 1000 && Array.isArray(data?.data?.rows)) {
                    const rows = data.data.rows.map((row) => ({
                        id: row.id,
                        name: row.name ?? "",
                        code: row.institution_code ?? String(row.id),
                        latitude: row.y_pos != null ? parseFloat(row.y_pos) : null,
                        longitude: row.x_pos != null ? parseFloat(row.x_pos) : null,
                        is_mapped: row.is_mapped === true,
                        mapping_id: row.mapping_id,
                        address: row.address,
                        phone: row.phone,
                    }));
                    dispatch(setPharmacyList(rows));
                    try {
                        localStorage.setItem(PHARMACY_CACHE_KEY, JSON.stringify({ list: rows, savedAt: Date.now() }));
                    } catch (e) { }
                }
                setPharmacyLoading(false);
            })
            .catch(() => setPharmacyLoading(false));
    }, [dispatch]);

    const requestLocation = useCallback(() => {
        if (!navigator.geolocation) {
            setLocationError("이 브라우저는 위치 기능을 지원하지 않습니다.");
            return;
        }
        console.log("[좌표계산] 시작");
        setLocationLoading(true);
        setLocationError(null);
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                console.log("[좌표계산] 완료", { lat, lng });
                const nextLocation = { lat, lng };
                setUserLocation(nextLocation);
                try {
                    localStorage.setItem("lastUserLocation", JSON.stringify(nextLocation));
                } catch (e) { }
                setLocationLoading(false);
                setLocationError(null);
            },
            (err) => {
                const msg = err.code === 1 ? "위치 권한이 거부되었습니다." :
                    err.code === 2 ? "위치를 확인할 수 없습니다." :
                        "위치를 가져오는데 실패했습니다.";
                console.log("[좌표계산] 실패", msg);
                setLocationLoading(false);
                setLocationError(msg);
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
    }, []);

    // GPS 위치 요청 (마운트 시 한 번 + 1분마다 자동 재계산)
    useEffect(() => {
        requestLocation();
        const intervalId = setInterval(requestLocation, 60000); // 1분(60초)마다
        return () => clearInterval(intervalId);
    }, [requestLocation]);

    // 결제 완료 여부 확인 함수
    const isPharmacyPaid = (pharmacy) => {
        return paidPharmacies.some(p =>
            p.name === pharmacy.name && p.code === pharmacy.code
        );
    };

    // 가맹약국 여부: API is_mapped === true
    const isFranchisePharmacy = (pharmacy) => pharmacy.is_mapped === true;

    // 거리 표시 포맷 (미터 → "150m", "1.2km")
    const formatDistance = (meters) => {
        if (meters == null) return "";
        if (meters < 1000) return `${Math.round(meters)}m`;
        return `${(meters / 1000).toFixed(1)}km`;
    };

    // 두 위경도 간 거리(미터) - Haversine
    const haversineDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371000; // 지구 반경(m)
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    // 약국 좌표: API y_pos(lat), x_pos(lng) 또는 latitude/longitude
    const getPharmacyCoords = (pharmacy) => {
        const lat = pharmacy.latitude ?? pharmacy.y_pos;
        const lng = pharmacy.longitude ?? pharmacy.x_pos;
        if (lat != null && lng != null) {
            return { lat: Number(lat), lng: Number(lng) };
        }
        const id = pharmacy.id || 0;
        return { lat: 37.56 + (id % 25) * 0.012, lng: 126.97 + (id % 25) * 0.018 };
    };

    // 근처 약국만 좌표 계산: 위경도 범위로 1차 필터 후 Haversine으로 상위 N개 (속도 절감)
    const NEARBY_DEGREE = 0.2; // 약 22km 이내만 거리 계산
    const getPharmaciesByDistance = (list, limit) => {
        if (!list || list.length === 0) return [];
        if (!userLocation) return [];
        const { lat, lng } = userLocation;
        const nearby = list.filter((p) => {
            const c = getPharmacyCoords(p);
            return Math.abs(c.lat - lat) <= NEARBY_DEGREE && Math.abs(c.lng - lng) <= NEARBY_DEGREE;
        });
        return nearby
            .map((p) => {
                const coords = getPharmacyCoords(p);
                const distance = haversineDistance(lat, lng, coords.lat, coords.lng);
                return { ...p, distance };
            })
            .sort((a, b) => a.distance - b.distance)
            .slice(0, limit);
    };

    // 가맹(is_mapped true) / 비가맹 목록 (메모이제이션으로 접었다 폈다 반응 개선)
    const registeredList = useMemo(
        () => pharmacyList.filter((p) => p.is_mapped === true),
        [pharmacyList]
    );
    const availableList = useMemo(
        () => pharmacyList.filter((p) => p.is_mapped !== true),
        [pharmacyList]
    );
    const franchiseCount = registeredList.length;
    const nonFranchiseCount = availableList.length;

    // 가맹약국 업체: 내 위치 기준 거리 계산 후 가까운 순 최대 3개 (계산 끝나면 그때 표시)
    const franchisePharmacies = useMemo(
        () => getPharmaciesByDistance(registeredList, 3),
        [registeredList, userLocation]
    );
    const nonFranchisePharmacies = useMemo(
        () => getPharmaciesByDistance(availableList, 2),
        [availableList, userLocation]
    );

    // 비가맹점 중 가까운 순 2개만 표시
    const nearestTwoPharmacies = useMemo(
        () => getPharmaciesByDistance(availableList, 2),
        [availableList, userLocation]
    );
    const nearestTwoIds = useMemo(
        () => new Set(nearestTwoPharmacies.map((p) => p.id)),
        [nearestTwoPharmacies]
    );

    const filteredPharmacies = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return [];
        return pharmacyList.filter((pharmacy) => {
            const name = (pharmacy.name || "").toLowerCase();
            const code = (pharmacy.code || "").toLowerCase();
            return (name.startsWith(term) || code.startsWith(term)) && !nearestTwoIds.has(pharmacy.id);
        });
    }, [pharmacyList, searchTerm, nearestTwoIds]);

    // 전체목록 최적화: 보이는 구간만 렌더 (스크롤 시 추가 로드)
    const visiblePharmacies = useMemo(
        () => filteredPharmacies.slice(0, listVisibleCount),
        [filteredPharmacies, listVisibleCount]
    );
    const hasMoreList = filteredPharmacies.length > listVisibleCount;

    // 상단 가맹/비가맹 섹션: 펼침 상태 (가까운 약국 박스)
    const [expandedTopFranchise, setExpandedTopFranchise] = useState(new Set());
    const [expandedTopNonFranchise, setExpandedTopNonFranchise] = useState(new Set());

    const toggleTopFranchiseDetails = useCallback((id) => {
        setExpandedTopFranchise((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);

    const toggleTopNonFranchiseDetails = useCallback((id) => {
        setExpandedTopNonFranchise((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);

    const handleListScroll = useCallback(() => {
        const el = listScrollRef.current;
        if (!el || !hasMoreList) return;
        const { scrollTop, scrollHeight, clientHeight } = el;
        if (scrollTop + clientHeight >= scrollHeight - 100) {
            setListVisibleCount((prev) => Math.min(prev + 150, filteredPharmacies.length));
        }
    }, [hasMoreList, filteredPharmacies.length]);

    // 검색어 바뀌면 보이는 개수 리셋
    useEffect(() => {
        setListVisibleCount(150);
    }, [searchTerm]);

    // 약국명 말줄임 처리
    const truncateNearbyName = (name = "") => {
        return name.length > 12 ? name.slice(0, 12) + "..." : name;
    };

    // 결제 버튼 클릭 시 수기결제로 이동 (앱 경로: /app/payment, currentSelectedPharmacyForPayment 사용)
    const handlePayment = (pharmacy) => {
        const payload = {
            name: pharmacy.name || "",
            code: pharmacy.code ?? String(pharmacy.id ?? ""),
            phone: pharmacy.phone || "",
            address: pharmacy.address || "",
        };
        localStorage.setItem("currentSelectedPharmacyForPayment", JSON.stringify(payload));
        navigate('/app/payment', { state: { from: '/app/dashboard_1', preferB: true } });
    };

    const confirmAppLogout = async () => {
        try {
            setLogoutLoading(true);
            try {
                await terminalLogout();
            } catch (e) {}
            dispatch(setOtpVerified(false));
            dispatch(checkLogin(false));
            setLogoutModalOpen(false);
            navigate('/app');
        } finally {
            setLogoutLoading(false);
        }
    };

    return (
        <div style={{
            ...(hideHeader ? { flex: 1, minHeight: 0 } : { height: "100dvh", minHeight: "100dvh" }),
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxWidth: "768px",
            margin: "0 auto",
            background: "#FFFFFF",
            overflow: "hidden"
        }}>
            <style>
                {`
                    button, a, [onClick] {
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent;
                        -webkit-touch-callout: none;
                        user-select: none;
                        transition: transform 0.1s ease, opacity 0.1s ease;
                    }
                    button:focus, a:focus, [onClick]:focus {
                        outline: none !important;
                    }
                    button:active, a:active, [onClick]:active {
                        outline: none !important;
                        transform: scale(0.96);
                        opacity: 0.8;
                    }
                    input:focus, select:focus, textarea:focus {
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent;
                        border-color: #E5E7EB !important;
                        box-shadow: none !important;
                    }
                    input, select, textarea {
                        outline: none !important;
                    }
                    input:focus-visible {
                        outline: none !important;
                        border-color: #E5E7EB !important;
                        box-shadow: none !important;
                    }
                `}
            </style>
            {!hideHeader && (
                /* 상단 영역 - AppDashboard와 동일: 로그아웃(왼쪽) | 로고(가운데) | A,B 토글 공간(오른쪽) */
                <div style={{
                    background: "linear-gradient(160deg, var(--brand-gradient-start) 0%, var(--brand-gradient-mid) 60%, var(--brand-gradient-end) 100%)",
                ...getTerminalHeaderStyle(),
                    height: "62px",
                    padding: "0 12px 0 10px",
                    color: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    boxSizing: "border-box"
                }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 2px",
                        width: "100%",
                        position: "relative",
                    }}>
                        <button
                            type="button"
                            onClick={() => setLogoutModalOpen(true)}
                            style={{ background: "transparent", border: "none", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center", color: "#FFFFFF" }}
                        >
                            <LogOut size={22} color="var(--terminal-header-foreground, #FFFFFF)" />
                        </button>
                        <img
                            src={getAppLogoAssetUrl()}
                            alt=''
                            onError={(e) => { e.target.src = getAppLogoFallbackUrl(); }}
                            style={getAppHeaderLogoStyle({
                                width: "150px",
                                height: "auto",
                                position: "absolute",
                                left: "50%",
                                transform: "translateX(-50%)",
                                pointerEvents: "none",
                            })}
                        />
                        {TERMINAL_PAYMENT_HISTORY_ENABLED && (<button
                            type="button"
                            onClick={() => navigate('/app/payment-list')}
                            style={{
                                padding: "6px 12px",
                                background: "#FFFFFF",
                                border: "1px solid var(--terminal-header-button-border, rgba(255,255,255,0.45))",
                                borderRadius: "8px",
                                fontSize: "13px",
                                fontWeight: 700,
                                color: "var(--brand-gradient-mid)",
                                cursor: "pointer",
                            }}
                        >
                            내역
                        </button>)}
                    </div>
                </div>
            )}

            {/* 중간 영역 - 가맹약국 업체 / 비가맹 업체 / 전체업체목록 */}
            <div style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                overflow: "hidden",
                minHeight: 0,
                width: "100%",
                boxSizing: "border-box"
            }}>
                {/* 가맹약국 업체 (가까운 순 3개) */}
                <div style={{
                    padding: "10px 16px 10px",
                    flexShrink: 0,
                    // minHeight: "190px",
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0px"
                    }}>
                        {pharmacyLoading && (
                            <p style={{ fontSize: "13px", color: "#6B7280", padding: "8px 0", margin: 0 }}>약국 목록을 불러오는 중…</p>
                        )}
                        {!pharmacyLoading && !userLocation && !locationLoading && (
                            <p style={{ fontSize: "13px", color: "#6B7280", padding: "8px 0", margin: 0 }}>위치 권한을 허용하면 내 주변 가까운 순으로 표시됩니다.</p>
                        )}
                        {!pharmacyLoading && franchisePharmacies.length === 0 && (registeredList.length === 0 || userLocation) && (
                            <p style={{ fontSize: "13px", color: "#6B7280", padding: "8px 0", margin: 0 }}>가맹약국이 없습니다.</p>
                        )}
                        {!pharmacyLoading && (() => {
                            const topThree = franchisePharmacies.slice(0, 3);
                            return topThree.map((pharmacy, index) => {
                            const isFirst = index === 0;
                            const isLast = index === topThree.length - 1;
                            const isOnly = topThree.length === 1;
                            const borderRadius = isOnly
                                ? "4px"
                                : isFirst
                                    ? "4px 4px 0 0"
                                    : isLast
                                        ? "0 0 4px 4px"
                                        : "0";

                            const isExpanded = expandedTopFranchise.has(pharmacy.id);

                            return (
                                <div
                                    key={pharmacy.id}
                                    style={{
                                        borderRadius,
                                        background: "#EFF6FF",
                                        borderBottom: index < topThree.length - 1 ? "1px solid #DBEAFE" : "none",
                                        padding: "10px 12px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: "8px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                minWidth: 0,
                                                display: "flex",
                                                alignItems: "baseline",
                                                gap: "6px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => toggleTopFranchiseDetails(pharmacy.id)}
                                        >
                                            <span
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: 600,
                                                    color: "#111827",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {truncateNearbyName(pharmacy.name)}
                                            </span>
                                            {pharmacy.distance != null && (
                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        color: "#6B7280",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {" | "}{formatDistance(pharmacy.distance)}
                                                </span>
                                            )}
                                        </div>

                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handlePayment(pharmacy);
                                            }}
                                            style={{
                                                background: "#3182F6",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "8px",
                                                padding: "6px 12px",
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                cursor: "pointer",
                                                whiteSpace: "nowrap",
                                                marginLeft: "10px",
                                                flexShrink: 0,
                                                minWidth: "60px",
                                            }}
                                        >
                                            결제
                                        </button>
                                    </div>

                                    {isExpanded && (
                                        <div
                                            style={{
                                                marginTop: "6px",
                                                borderTop: "1px solid #DBEAFE",
                                                paddingTop: "6px",
                                                fontSize: "13px",
                                                color: "#4B5563",
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            <div style={{ marginBottom: "2px" }}>
                                                <span style={{ fontWeight: 600 }}>연락처</span>
                                                <span style={{ marginLeft: "6px" }}>
                                                    {pharmacy.phone || "-"}
                                                </span>
                                            </div>
                                            <div>
                                                <span style={{ fontWeight: 600 }}>주소</span>
                                                <span style={{ marginLeft: "6px" }}>
                                                    {pharmacy.address || "-"}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        });
                        })()}
                    </div>
                </div>

                {/* 검색창 (가맹약국 바로 아래) */}
                <div style={{
                    padding: "12px 16px 10px",
                    flexShrink: 0,
                    borderTop: "1px solid #E5E7EB",
                    background: "#FAFAFA",
                }}>
                    <div style={{ position: "relative" }}>
                        <Search
                            size={18}
                            style={{
                                position: "absolute",
                                left: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#9CA3AF",
                            }}
                        />
                        <input
                            type="text"
                            placeholder="약국명으로 검색하세요."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px 38px 10px 38px",
                                border: "none",
                                borderBottom: "1px solid #E5E7EB",
                                borderRadius: 0,
                                fontSize: "15px",
                                background: "#fff",
                                outline: "none",
                            }}
                        />
                        {searchTerm && (
                            <button
                                onClick={() => setSearchTerm("")}
                                style={{
                                    position: "absolute",
                                    right: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    background: "#E5E7EB",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "50%",
                                }}
                            >
                                <X size={16} color="#6B7280" />
                            </button>
                        )}
                    </div>
                </div>

                {/* 비가맹 업체 (근거리약국 섹션 - 현재 숨김) */}
                {false && (
                    <div style={{
                        padding: "10px 16px 6px",
                        flexShrink: 0,
                    }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "6px",
                            padding: "0",
                        }}>
                            <button
                                type="button"
                                onClick={() => setFoldNonFranchise((prev) => !prev)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    padding: "0",
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    flex: 1,
                                }}
                            >
                                <h2 style={{
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    margin: 0,
                                    color: "#717171"
                                }}>
                                    근거리약국
                                </h2>
                                <FontAwesomeIcon
                                    icon={foldNonFranchise ? faChevronDown : faChevronUp}
                                    style={{ fontSize: "20px", color: "#6B7280" }}
                                />
                            </button>
                        </div>

                        {!foldNonFranchise && (
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "0px"
                            }}>
                                {pharmacyLoading && (
                                    <p style={{ fontSize: "13px", color: "#6B7280", padding: "8px 0", margin: 0 }}>약국 목록을 불러오는 중…</p>
                                )}
                                {!pharmacyLoading && !userLocation && !locationLoading && (
                                    <p style={{ fontSize: "13px", color: "#6B7280", padding: "8px 0", margin: 0 }}>위치 권한을 허용하면 내 주변 가까운 순으로 표시됩니다.</p>
                                )}
                            {!pharmacyLoading && nonFranchisePharmacies.map((pharmacy, index) => {
                                const isExpanded = expandedTopNonFranchise.has(pharmacy.id);
                                    return (
                                        <div
                                            key={pharmacy.id}
                                            style={{
                                                padding: "8px 0px 4px",
                                                borderBottom: "1px solid #F3F4F6"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    gap: "8px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        display: "flex",
                                                        alignItems: "baseline",
                                                        gap: "6px",
                                                        cursor: "pointer",
                                                    }}
                                                onClick={() => toggleTopNonFranchiseDetails(pharmacy.id)}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "18px",
                                                            fontWeight: 600,
                                                            color: "#111827",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {truncateNearbyName(pharmacy.name)}
                                                    </span>
                                                    {pharmacy.distance != null && (
                                                        <span
                                                            style={{
                                                                fontSize: "13px",
                                                                color: "#6B7280",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {" | "}{formatDistance(pharmacy.distance)}
                                                        </span>
                                                    )}
                                                </div>

                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePayment(pharmacy);
                                                    }}
                                                    style={{
                                                        background: "#3182F6",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "8px",
                                                        padding: "6px 12px",
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: "10px",
                                                        flexShrink: 0,
                                                        minWidth: "60px",
                                                    }}
                                                >
                                                    결제
                                                </button>
                                            </div>

                                            {isExpanded && (
                                                <div
                                                    style={{
                                                        marginTop: "6px",
                                                        borderTop: "1px solid #E5E7EB",
                                                        paddingTop: "6px",
                                                        fontSize: "13px",
                                                        color: "#4B5563",
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    <div style={{ marginBottom: "2px" }}>
                                                        <span style={{ fontWeight: 600 }}>연락처</span>
                                                        <span style={{ marginLeft: "6px" }}>
                                                            {pharmacy.phone || "-"}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span style={{ fontWeight: 600 }}>주소</span>
                                                        <span style={{ marginLeft: "6px" }}>
                                                            {pharmacy.address || "-"}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}

                {/* 업체 목록 */}
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    overflow: "hidden",
                    minHeight: 0,
                    width: "100%",
                    boxSizing: "border-box"
                }}>
                    <div
                        ref={listScrollRef}
                        onScroll={handleListScroll}
                        style={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "hidden",
                            minHeight: 0,
                            WebkitOverflowScrolling: "touch",
                            padding: "0 16px 16px",
                            background: "#fff",
                        }}
                    >
                        {pharmacyLoading ? (
                            <div style={{ padding: "32px 18px", textAlign: "center" }}>
                                <p style={{ color: "#9CA3AF", fontSize: "14px" }}>약국 목록을 불러오는 중…</p>
                            </div>
                        ) : !searchTerm.trim() && nearestTwoPharmacies.length === 0 ? (
                            <div style={{ padding: "20px 12px", textAlign: "center", fontSize: "14px", color: "#6B7280" }}>
                                근거리 정보가 없습니다.
                            </div>
                        ) : searchTerm.trim() && filteredPharmacies.length === 0 && nearestTwoPharmacies.length === 0 ? (
                            <div style={{ padding: "20px 12px", textAlign: "center", fontSize: "14px", color: "#6B7280" }}>
                                검색 결과가 없습니다.
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0px",
                                }}
                            >
                                {/* 근거리 2개 */}
                                {nearestTwoPharmacies.map((pharmacy) => {
                                    const displayName = `${pharmacy.name || ""}${pharmacy.code ? `(${pharmacy.code})` : ""}`;
                                    return (
                                        <div
                                            key={pharmacy.id}
                                            style={{
                                                padding: "10px 6px",
                                                borderBottom: "1px solid #E5E7EB",
                                                background: "#FFFFFF",
                                            }}
                                        >
                                            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "8px" }}>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div style={{ fontSize: "15px", fontWeight: 600, color: "#111827" }}>
                                                        {displayName}
                                                    </div>
                                                    <div
                                                        style={{
                                                            marginTop: "4px",
                                                            fontSize: "13px",
                                                            color: "#6B7280",
                                                            lineHeight: 1.4,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {pharmacy.address || "-"}
                                                    </div>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => handlePayment(pharmacy)}
                                                    style={{
                                                        background: "#3182F6",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "8px",
                                                        padding: "6px 12px",
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap",
                                                        flexShrink: 0,
                                                        minWidth: "60px",
                                                        alignSelf: "center",
                                                    }}
                                                >
                                                    결제
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* 검색 결과 (근거리 2개는 제외) */}
                                {searchTerm.trim() &&
                                    visiblePharmacies.map((pharmacy) => {
                                        const displayName = `${pharmacy.name || ""}${pharmacy.code ? `(${pharmacy.code})` : ""}`;
                                        return (
                                            <div
                                                key={pharmacy.id}
                                                style={{
                                                    padding: "10px 6px",
                                                    borderBottom: "1px solid #E5E7EB",
                                                    background: "#FFFFFF",
                                                }}
                                            >
                                                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "8px" }}>
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontSize: "15px", fontWeight: 600, color: "#111827" }}>
                                                            {displayName}
                                                        </div>
                                                        <div
                                                            style={{
                                                                marginTop: "4px",
                                                                fontSize: "13px",
                                                                color: "#6B7280",
                                                                lineHeight: 1.4,
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {pharmacy.address || "-"}
                                                        </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => handlePayment(pharmacy)}
                                                        style={{
                                                            background: "#3182F6",
                                                            color: "#fff",
                                                            border: "none",
                                                            borderRadius: "8px",
                                                            padding: "6px 12px",
                                                            fontSize: "13px",
                                                            fontWeight: 600,
                                                            cursor: "pointer",
                                                            whiteSpace: "nowrap",
                                                            flexShrink: 0,
                                                            minWidth: "60px",
                                                            alignSelf: "center",
                                                        }}
                                                    >
                                                        결제
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {!hideHeader && (
                <AppLogoutConfirmModal
                    open={logoutModalOpen}
                    onCancel={() => {
                        if (!logoutLoading) setLogoutModalOpen(false);
                    }}
                    onConfirm={confirmAppLogout}
                    loading={logoutLoading}
                />
            )}
        </div>
    )
}

export default AppDashboard_1;
